import { isVivaExamEnabled as isVivaExamEnabledEpic } from 'bundles/academic-integrity/lib/epics';
import type { AcademicIntegritySettingsFragment } from 'bundles/assignment-submission/components/api/assignment-submission-api/__generated__/AssignmentSubmission';

export const isVivaExamEnabled = (
  courseId: string,
  itemId: string,
  integritySettings?: AcademicIntegritySettingsFragment | null
) => {
  if (
    integritySettings?.vivaExamSettings?.status === 'ENABLED' ||
    integritySettings?.vivaExamSettings?.status === 'ENABLED_WITH_FEEDBACK'
  ) {
    return true;
  }
  // TODO: remove this once we have tested the BE changes and just return false
  return isVivaExamEnabledEpic(courseId, itemId);
};
